import * as api from '../../api/api-declaracion-pago';
import { 
    GET_CONFIG_FORM85,
    GET_CUOTAS
  
    
} from '../types';

export const configuracionFormAction85 = (query) => ({
    type: GET_CONFIG_FORM85,
    payload: api.getConfiguracionForm85(query)
});
export const obtenerCuotas = (query) => ({
    type: GET_CUOTAS,
    payload: api.getCuotas(query)
});
